var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1044_8406)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.275 0.561683C12.6717 0.956915 12.6717 1.59771 12.275 1.99295L5.88222 8.3617L12.275 14.7305C12.6717 15.1257 12.6717 15.7665 12.275 16.1617C11.8783 16.557 11.2351 16.557 10.8383 16.1617L3.72723 9.07734C3.33051 8.6821 3.33051 8.0413 3.72723 7.64607L10.8383 0.561683C11.2351 0.166451 11.8783 0.166451 12.275 0.561683Z",
    fill: "#B3B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1044_8406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16.1929,
    fill: "white",
    transform: "translate(0 0.265259)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.d1386bcecbab6d2d03ccd7d03de485dc.svg";
export { ForwardRef as ReactComponent };